import React from 'react';
import { AlertFloating } from './styles';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export function WarningMicrophoneCall() {
    return (
        <AlertFloating icon={<ErrorOutlineIcon />} severity='warning'>
            Your microphone isn’t working. Switch to a different device or try reconnecting this one.
        </AlertFloating>
    );
}

export default WarningMicrophoneCall;
